import { render, staticRenderFns } from "./LiveStockRegister.vue?vue&type=template&id=55a3dcfa&scoped=true&"
import script from "./LiveStockRegister.vue?vue&type=script&lang=ts&"
export * from "./LiveStockRegister.vue?vue&type=script&lang=ts&"
import style0 from "./LiveStockRegister.vue?vue&type=style&index=0&id=55a3dcfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a3dcfa",
  null
  
)

export default component.exports